import React, { useState, useEffect } from 'react';
import { db, storage } from '../FireBase'; // Import Firestore and Storage
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import { Modal, Button, Table, Form, Spinner,Row,Col ,Tab,Tabs,Container} from 'react-bootstrap'; // Bootstrap components
import { collection, getDocs,addDoc,deleteDoc,doc,updateDoc,query,where,setDoc,orderBy,getDoc} from 'firebase/firestore'; // Import Firestore functions
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'; // Import required functions
import ToastAlert from '../components/ToastAlert';
import { faChartBar, faCheck, faCopy, faEdit, faFaceAngry, faFileExcel, faFloppyDisk, faGear, faPlus, faRightLeft, faTrash, faTree, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { FaArrowRotateLeft, FaPlus, FaResearchgate, FaTrash, FaTruck } from 'react-icons/fa6';
import Loading from '../components/Loading';
import { generateExcelReport } from '../components/reportUtils';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SchemeCategoryModal from '../components/SchemeCategoryModal';


const Schemes = () => {
  const [schemes, setSchemes] = useState([]);
  const [schemeData, setSchemeData] = useState({
    name: '',
    image: '',
    productDetails: [],
    price: 0,
    onboardingStart: '',
    onboardingEnd: '',
    Description: '',
    SchemeStart: '',
    settlementDetails:'',
    singlePaymentDiscount:0,
  });
  const [imageUploading, setImageUploading] = useState(false);
  const [showModal, setShowModal] = useState(false); // For modal visibility
  const [selectedProduct, setSelectedProduct] = useState({ productId: '', quantity: 1 });
  const [products, setProducts] = useState([]); // To store fetched products
 
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [activeSchemes, setActiveSchemes] = useState([]);
  const [completedSchemes, setCompletedSchemes] = useState([]);

  const [isEditing, setIsEditing] = useState(false);
  const [editingScheme, setEditingScheme] = useState(null);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]); // State for gallery images
  const [deletedSchemes,setDeletedSchemes] = useState([]);
  const [searchTerm1, setSearchTerm1] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [showSchemeCategoryModal, setSchemeCategoryShowModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);


  const fetchSchemes = async () => {
    try {
      setLoading(true);
  
      const schemesQuery = query(
        collection(db, "schemes"),
        orderBy("createdAt", "desc")
      );
  
      const querySnapshot = await getDocs(schemesQuery);
      let schemesData = querySnapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }))
        .filter((doc) => doc.deleted !== true); // ✅ This ensures we skip deleted OR missing
  
      const updatedSchemes = await Promise.all(
        schemesData.map(async (scheme) => {
          const totalUsersQuery = query(
            collection(db, "subscriptions"),
            where("schemeId", "==", scheme.id)
          );
          const totalUsersSnapshot = await getDocs(totalUsersQuery);
          const totalUsers = totalUsersSnapshot.size;
          const completedUsers = totalUsersSnapshot.docs.filter(
            (doc) =>
              parseInt(doc.data().totalMonths) === parseInt(doc.data().paidMonths)
          ).length;
  
          return { ...scheme, totalUsers, completedUsers };
        })
      );
  
      setActiveSchemes(updatedSchemes.filter((s) => s.status !== "Completed"));
      setCompletedSchemes(updatedSchemes.filter((s) => s.status === "Completed"));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching schemes:", error);
      setLoading(false);
    }finally{setLoading(false);}
  };

  const fetchCategories = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "scheme_categories"));
    const categoryData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setCategories(categoryData.filter((cat) => cat.status === true)); // show only active categories
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};


  const fetchDeletedSchemes = async () => {
    try {
      setLoading(true);
  
      const deletedSchemesQuery = query(
        collection(db, "schemes"),
        where("deleted", "==", true),
        orderBy("deletedAt", "desc")
      );
  
      const querySnapshot = await getDocs(deletedSchemesQuery);
      const deletedSchemes = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      console.log(deletedSchemes)
      setDeletedSchemes(deletedSchemes); // You need to define and set this state
      setLoading(false);
    } catch (error) {
      console.error("Error fetching deleted schemes:", error);
      setLoading(false);
    }
  };
  
  
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, 'products')); // Fetch products
      const productsData = querySnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setProducts(productsData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };
  // Fetch schemes from Firestore
  useEffect(() => {
    
    
    // fetchProducts();
    // fetchSchemes();
    // fetchDeletedSchemes();
    fetchAllFunctions();
  }, []);

const fetchAllFunctions = async () => {
  try {
    setLoading(true);

    await Promise.all([
      fetchProducts(),
      fetchSchemes(),
      fetchDeletedSchemes(),
      fetchCategories()
    ]);

  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};


  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSchemeData({
      ...schemeData,
      [name]: value,
    });
  };


  const handleImageUpload = async (e) => {
    const file = e.target.files[0]; // File from input
    if (file) {
      try {
        setImageUploading(true);
        // Create a reference to the file location in Storage
        const storageRef = ref(storage, `schemeImages/${file.name}`);
        
        // Upload the file
        await uploadBytes(storageRef, file);
        
        // Get the file's download URL
        const downloadURL = await getDownloadURL(storageRef);
  
        // Set the download URL in the form state
        setSchemeData({
          ...schemeData,
          image: downloadURL,
        });
        console.log("Image uploaded successfully:", downloadURL);
        setImageUploading(false);
      } catch (error) {
        console.error("Error uploading image:", error);
      }
      finally{
        setImageUploading(false);
      }
    }
  };
  
    // Handle adding a product to the scheme
    const handleAddProduct = () => {
      if (selectedProduct.productId && selectedProduct.quantity > 0) {
        // Check if the product is already in the list
        const isDuplicate = schemeData.productDetails.some(
          (p) => p.productId === selectedProduct.productId
        );
    
        if (isDuplicate) {
          setToastMessage('This product already in the list!!');
          setToastVariant('warning');
          setShowToast(true);
          return;
        }
    
        const product = products.find((p) => p.id === selectedProduct.productId);
        setSchemeData({
          ...schemeData,
          productDetails: [
            ...schemeData.productDetails,
            {
                productId: product.id,
                productName: product.name, // Assuming products have a "name" field
                quantity: selectedProduct.quantity,
                unitType: product.unitType, // Assuming products have a "unitType" field
                unitValue: product.unitValue, // Assuming products have a "unitValue" field
            },  
          ],
        });
        setSelectedProduct({ productId: '', quantity: 1 }); // Reset selection
      }
    };
    
// Handle adding a new scheme
const handleAddScheme = async (e) => {
  e.preventDefault();
  try {
    setLoading(true);

    // Generate a unique scheme ID
    const schemeId = `SCH${Date.now().toString().slice(-6)}`;

    // Calculate total scheme value
    const totalSchemeValue = schemeData.price * schemeData.schemeDuration;

    // Reference for the new scheme
    const docRef = doc(db, "schemes", schemeId);

    // Save scheme data along with scheme settings as an array
    await setDoc(docRef, {
      ...schemeData,
      schemeId,
      categoryId: selectedCategory ? selectedCategory.id : null, // ✅ added
      categoryName: selectedCategory ? selectedCategory.name : "", // optional
      totalSchemeValue,
      createdAt: new Date(),
      status: false,
      galleryImages,
      late_fee: [
        {
          dueDateFrom: parseInt(schemeData.dueDateFrom),
          dueDateTo: parseInt(schemeData.dueDateTo),
          lateFee: parseFloat(schemeData.lateFee),
        }
      ],
      singlePaymentDiscount:parseInt(schemeData.singlePaymentDiscount),
    });

    // Update local state with the new scheme
    const newScheme = {
      ...schemeData,
      totalSchemeValue,
      id: docRef.id, // Firestore document ID
      late_fee: [
        {
          dueDateFrom: parseInt(schemeData.dueDateFrom),
          dueDateTo: parseInt(schemeData.dueDateTo),
          lateFee: parseFloat(schemeData.lateFee),
        }
      ],
     singlePaymentDiscount:parseInt(schemeData.singlePaymentDiscount),
    };
    setSchemes([...schemes, newScheme]);

    // Reset form fields
    setSchemeData({
      name: '',
      image: '',
      categoryId:'',
      categoryName: '',
      productDetails: [],
      price: 0,
      schemeDuration: 0,
      onboardingStart: '',
      onboardingEnd: '',
      Description: '',
      settlementDetails:'',
      SchemeStart: '',
      dueDateFrom: '',
      dueDateTo: '',
      lateFee: '',
      singlePaymentDiscount:0,
    });
    setGalleryImages([]);

    // Show success toast
    setToastMessage('Scheme added successfully!');
    setToastVariant('success');
    setShowToast(true);
    setShowModal(false);

    // Refresh data if needed
    fetchAllFunctions();

    setLoading(false);
  } catch (error) {
    console.error('Error adding scheme:', error);
    setToastMessage('Error adding scheme. Please try again.');
    setToastVariant('danger');
    setShowToast(true);
    setLoading(false);
  }
};


  const handleDeleteSchemeFully = async (schemeId) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        // Reference the specific document using the doc function
        setLoading(true);
        await deleteDoc(doc(db, 'schemes', schemeId));
        setActiveSchemes(activeSchemes.filter((scheme) => scheme.id !== schemeId));
        setCompletedSchemes(completedSchemes.filter((scheme) => scheme.id !== schemeId));
     
        setToastMessage('Scheme deleted successfully');
        setToastVariant('danger'); // Use 'danger' for the alert variant
        setShowToast(true);
  
        // Optionally update local state to remove the deleted scheme
        setSchemes(schemes.filter((scheme) => scheme.id !== schemeId));
        setLoading(false);
        fetchAllFunctions();
      } catch (error) {
        console.error('Error deleting product:', error);
        setToastMessage('Error deleting product. Please try again.');
        setToastVariant('warning'); // Use 'warning' for the alert variant
        setShowToast(true);
      }
    }
  };
  const handleDeleteScheme = async (schemeId) => {
    if (window.confirm('Are you sure you want to delete this scheme?')) {
      try {
        setLoading(true);
  
        // Soft delete by setting `deleted: true`
        const schemeRef = doc(db, 'schemes', schemeId);
        await updateDoc(schemeRef, {
          deleted: true,
          deletedAt: new Date().toISOString(),
        });
  
        // Remove from local state
        setActiveSchemes(activeSchemes.filter((scheme) => scheme.id !== schemeId));
        setCompletedSchemes(completedSchemes.filter((scheme) => scheme.id !== schemeId));
        setSchemes(schemes.filter((scheme) => scheme.id !== schemeId));
  
        setToastMessage('Scheme marked as deleted');
        setToastVariant('danger');
        setShowToast(true);
        fetchAllFunctions();
      } catch (error) {
        console.error('Error marking scheme as deleted:', error);
        setToastMessage('Error deleting scheme. Please try again.');
        setToastVariant('warning');
        setShowToast(true);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleRecover = async (schemeId) => {
    if (window.confirm('Are you sure you want to recover this scheme?')) {
      try {
        setLoading(true);
  
        // Soft delete by setting `deleted: true`
        const schemeRef = doc(db, 'schemes', schemeId);
        await updateDoc(schemeRef, {
          deleted: false,
          deletedAt: new Date().toISOString(),
        });
  
        // Remove from local state
        setActiveSchemes(activeSchemes.filter((scheme) => scheme.id !== schemeId));
        setCompletedSchemes(completedSchemes.filter((scheme) => scheme.id !== schemeId));
        setSchemes(schemes.filter((scheme) => scheme.id !== schemeId));
  
        setToastMessage('Scheme recover successfully');
        setToastVariant('success');
        setShowToast(true); 
        fetchAllFunctions();
      } catch (error) {
        console.error('Error marking scheme as deleted:', error);
        setToastMessage('Error deleting scheme. Please try again.');
        setToastVariant('warning');
        setShowToast(true);
      } finally {
        setLoading(false);
      }
    }
  };
  
  const handleRemoveProduct = (index) => {
    setLoading(true);
    const updatedProducts = [...schemeData.productDetails];
    updatedProducts.splice(index, 1); // Remove the selected product by index
    setSchemeData({
      ...schemeData,
      productDetails: updatedProducts,
    });
    setLoading(false);
  };

  const handleToggleStatus = async (schemeId, currentStatus) => {
   
    try {
      const schemeRef = doc(db, 'schemes', schemeId);
  
      // Toggle the status value and update Firestore
      const newStatus = !currentStatus;
      await updateDoc(schemeRef, { status: newStatus });
  
      // Update local state to reflect the change
      setActiveSchemes((prevSchemes) =>
        prevSchemes.map((scheme) =>
          scheme.id === schemeId ? { ...scheme, status: newStatus } : scheme
        )
      );
  
      setCompletedSchemes((prevSchemes) =>
        prevSchemes.map((scheme) =>
          scheme.id === schemeId ? { ...scheme, status: newStatus } : scheme
        )
      );
  
      setToastMessage(`Scheme ${newStatus ? 'activated' : 'deactivated'} successfully.`);
      setToastVariant('success');
      setShowToast(true);
      fetchAllFunctions();
    } catch (error) {
      console.error('Error toggling scheme status:', error);
      setToastMessage('Error updating scheme status. Please try again.');
      setToastVariant('danger');
      setShowToast(true);
    }
  };
  
  const handleCompleteAndClose = async (schemeId) => {
    try {
      setLoading(true);
      const schemeRef = doc(db, 'schemes', schemeId);
      await updateDoc(schemeRef, { status: "Completed" ,completedAt: new Date(),});

      // Update local state
      setActiveSchemes((prevSchemes) =>
          prevSchemes.filter((scheme) => scheme.id !== schemeId)
      );

      const completedScheme = activeSchemes.find((scheme) => scheme.id === schemeId);
      setCompletedSchemes((prevSchemes) => [
          ...prevSchemes,
          { ...completedScheme, status: "Completed" },
      ]);

      setToastMessage('Scheme marked as completed successfully.');
      setToastVariant('success');
      setShowToast(true);
      setLoading(false);
      fetchAllFunctions();
  } catch (error) {
      console.error('Error marking scheme as complete:', error);
      setToastMessage('Error completing the scheme. Please try again.');
      setToastVariant('danger');
      setShowToast(true);
  }
  };
const handleEditScheme = async (e) => {
  e.preventDefault();
  try {
    setLoading(true);

    const schemeRef = doc(db, 'schemes', editingScheme.id);
    const totalSchemeValue = schemeData.price * schemeData.schemeDuration;

    // Update scheme including late_fee array
    await updateDoc(schemeRef, {
      ...schemeData,
       categoryId: selectedCategory ? selectedCategory.id : null,
      categoryName: selectedCategory ? selectedCategory.name : "",
      totalSchemeValue,
      galleryImages,
      late_fee: [
        {
          dueDateFrom: parseInt(schemeData.dueDateFrom),
          dueDateTo: parseInt(schemeData.dueDateTo),
          lateFee: parseFloat(schemeData.lateFee),
        }
      ],
      singlePaymentDiscount:parseInt(schemeData.singlePaymentDiscount),
    });

    // Update local state
    setActiveSchemes((prevSchemes) =>
      prevSchemes.map((scheme) =>
        scheme.id === editingScheme.id
          ? {
              ...scheme,
              ...schemeData,
              galleryImages,
              late_fee: [
                {
                  dueDateFrom: parseInt(schemeData.dueDateFrom),
                  dueDateTo: parseInt(schemeData.dueDateTo),
                  lateFee: parseFloat(schemeData.lateFee),
                }
              ],
              singlePaymentDiscount:parseInt(schemeData.singlePaymentDiscount),
            }
          : scheme
      )
    );

    // Reset form fields
    setSchemeData({
      name: '',
      image: '',
      productDetails: [],
      price: 0,
      schemeDuration: 0,
      onboardingStart: '',
      onboardingEnd: '',
      Description: '',
      settlementDetails:'',
      SchemeStart: '',
      dueDateFrom: '',
      dueDateTo: '',
      lateFee: '',
      singlePaymentDiscount:0,
    });
    setGalleryImages([]);

    console.log('Scheme updated successfully!');
    setToastMessage('Scheme updated successfully!');
    setToastVariant('success');
    setShowToast(true);
    setShowModal(false);
    setIsEditing(false); // Close the edit modal
    setLoading(false);
    fetchAllFunctions();
  } catch (error) {
    console.error('Error updating scheme:', error);
    setToastMessage('Error updating scheme. Please try again.');
    setToastVariant('danger');
    setShowToast(true);
    setLoading(false);
  }
};

const openEditModal = (scheme) => {
  setEditingScheme(scheme);
  setSchemeData({
    name: scheme.name,
    image: scheme.image,
    productDetails: scheme.productDetails,
    price: scheme.price,
    schemeDuration: scheme.schemeDuration,
    onboardingStart: scheme.onboardingStart,
    onboardingEnd: scheme.onboardingEnd,
    Description: scheme.Description,
    settlementDetails:scheme.settlementDetails,
    SchemeStart: scheme.SchemeStart,
    dueDateFrom: scheme.late_fee?.[0]?.dueDateFrom || '',
    dueDateTo: scheme.late_fee?.[0]?.dueDateTo || '',
    lateFee: scheme.late_fee?.[0]?.lateFee || '',
    singlePaymentDiscount:scheme.singlePaymentDiscount ||0,
  });
  setSelectedCategory(
    scheme.categoryId && scheme.categoryName
      ? { id: scheme.categoryId, name: scheme.categoryName }
      : null
  );

  setGalleryImages(scheme.galleryImages || []);
  setIsEditing(true);
  setShowModal(true);
};

  const handleCloseModal = () => {
      setShowModal(false);
      resetFormData(); // Call a function to reset form data
  };

  const resetFormData = () => {
      setSchemeData({
          name: '',
          image: '',
          productDetails: [],
          price: 0,
          schemeDuration: 0,
          onboardingStart: '',
          onboardingEnd: '',
          Description: '',
          settlementDetails:'',
          SchemeStart: '',
      });
      setIsEditing(false); // Reset editing state
      setEditingScheme(null); // Clear editing scheme
  };
  
  const handleShowSettingsModal = () => setShowSettingsModal(true);
  const handleCloseSettingsModal = () => setShowSettingsModal(false);

 
const downloadReport = async () => {
  const formatDate = (date) => {
      if (date instanceof Date) {
          return date.toLocaleDateString();
      } else if (date && date.seconds) {
          return new Date(date.seconds * 1000).toLocaleDateString();
      }
      return date;
  };

  const fetchSchemeData = async (scheme) => {
      const customers = [];
      const transactions = [];

      // Fetch subscriptions matching the scheme
      const subQuery = query(collection(db, "subscriptions"), where("schemeId", "==", scheme.id));
      const subSnapshot = await getDocs(subQuery);

      const customerIds = new Set();
      subSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.userId) customerIds.add(data.userId);
      });

      // Fetch user details
     
    for (const userId of customerIds) {
      const userQuery = query(collection(db, "users"), where("cusmid", "==", userId));
      const userSnap = await getDocs(userQuery);

          userSnap.forEach(doc => {
            const user = doc.data();
        
            let addressStr = '';
        
            // Handle if address is an array
            if (Array.isArray(user.address)) {
                addressStr = user.address.map(a =>
                    `${a.address || ''}, ${a.city || ''}, ${a.state || ''}, ${a.country || ''}, ${a.postalCode || ''}`
                ).join(" | ");
            }
            // Handle if address is a single object
            else if (user.address && typeof user.address === 'object') {
                const a = user.address;
                addressStr = `${a.address || ''}, ${a.city || ''}, ${a.state || ''}, ${a.country || ''}, ${a.postalCode || ''}`;
            }
        
            customers.push({
                id: user.cusmid,
                name: user.name,
                email: user.email,
                phone: user.phone,
                address: addressStr
            });
        });
    
    }

      // Fetch transactions for this scheme
      const txQuery = query(collection(db, "transactions"), where("schemeId", "==", scheme.id));
      const txSnapshot = await getDocs(txQuery);

      txSnapshot.forEach(doc => {
          const tx = doc.data();
          transactions.push({
              id: tx.transactionId,
              customerId: tx.userId,
              amount: tx.paymentAmount,
              type:tx.paymentType,
              date: tx.paymentDate,
          });
      });

      return { ...scheme, customers, transactions };
  };

  const generateSchemeSheet = (scheme) => {
      const sheetData = [];

      // Scheme Details
      sheetData.push(['Scheme Details']);
      sheetData.push(['ID', scheme.id]);
      sheetData.push(['Status', scheme.status]);
      sheetData.push(['Name', scheme.name]);
      sheetData.push(['Description', scheme.Description]);
      sheetData.push(['settlementDetails',scheme.settlementDetails]);
      sheetData.push(['Created', formatDate(scheme.createdAt)]);
      sheetData.push(['Price', scheme.price]);
      sheetData.push(['Duration', scheme.schemeDuration]);
      sheetData.push(['Total Value', scheme.totalSchemeValue]);
      sheetData.push(['Start Date', formatDate(scheme.SchemeStart)]);
      sheetData.push(['Onboarding Start', formatDate(scheme.onboardingStart)]);
      sheetData.push(['Onboarding End', formatDate(scheme.onboardingEnd)]);
      sheetData.push([]);

      // Customer List
      sheetData.push(['Customer List']);
      sheetData.push(['Customer ID', 'Name', 'Email', 'Phone','Address']);
      (scheme.customers || []).forEach(c => {
          sheetData.push([c.id, c.name, c.email, c.phone,c.address]);
      });
      sheetData.push([]);

      // Transactions
      sheetData.push(['Transaction List']);
      sheetData.push(['Transaction ID','Customer id', 'Amount', 'Date', 'Type']);
      (scheme.transactions || []).forEach(t => {
          sheetData.push([t.id,t.customerId, t.amount, formatDate(t.date), t.type]);
      });

      return {
          name: scheme.name.substring(0, 31),
          data: sheetData
      };
  };

  const generateExcelReport = (sheets, fileName) => {
      const wb = XLSX.utils.book_new();
      sheets.forEach(sheet => {
          const ws = XLSX.utils.aoa_to_sheet(sheet.data);
          XLSX.utils.book_append_sheet(wb, ws, sheet.name);
      });
      XLSX.writeFile(wb, fileName);
  };

  const allSchemes = [...activeSchemes, ...completedSchemes,];
  const enrichedSchemes = await Promise.all(allSchemes.map(fetchSchemeData));
  const schemeSheets = enrichedSchemes.map(generateSchemeSheet);

  generateExcelReport(schemeSheets, 'Detailed_Scheme_Report.xlsx');
};

      const formatAddress = (address) => {
        if (typeof address === 'object') {
            return `${address.address}, ${address.city}, ${address.state}, ${address.postalCode}, ${address.country}`;
        }
        return address;
    }

  if (loading) {
    // Render loading screen
    return (
      <div className="loading-screen">
      <Loading/>
      </div>
    );
  }
  const handleDuplicateScheme = async (scheme) => {
      if (window.confirm(`Are you sure you want to duplicate ${scheme.name}?`)) {
    try {
      
        const newSchemeId = `SCH${Date.now().toString().slice(-6)}`;
        const newScheme = {
            ...scheme,
            id: newSchemeId,
            schemeId: newSchemeId,
            name: `${scheme.name} (Copy)`,
            createdAt: new Date(),
            status: false,
        };

        const docRef = doc(db, "schemes", newSchemeId);
        await setDoc(docRef, newScheme);

        setSchemes([...schemes, newScheme]);
        setActiveSchemes([...activeSchemes, newScheme]);

        setToastMessage('Scheme duplicated successfully!');
        setToastVariant('success');
        setShowToast(true);
        fetchAllFunctions();

    } catch (error) {
        console.error('Error duplicating scheme:', error);
        setToastMessage('Error duplicating scheme. Please try again.');
        setToastVariant('danger');
        setShowToast(true);
    }
  }
};

const handleGalleryImageUpload = async (e) => {
  const files = Array.from(e.target.files); // Get multiple files
  const uploadedImages = [];

  try {
    setImageUploading(true);

    for (const file of files) {
      // Create a reference to the file location in Storage
      const storageRef = ref(storage, `schemeGalleryImages/${file.name}`);

      // Upload the file
      await uploadBytes(storageRef, file);

      // Get the file's download URL
      const downloadURL = await getDownloadURL(storageRef);
      uploadedImages.push(downloadURL);
    }

    // Update the gallery images state
    setGalleryImages([...galleryImages, ...uploadedImages]);
    console.log("Gallery images uploaded successfully:", uploadedImages);
  } catch (error) {
    console.error("Error uploading gallery images:", error);
  } finally {
    setImageUploading(false);
  }
};

const handleRemoveGalleryImage = (index) => {
  const updatedGalleryImages = [...galleryImages];
  updatedGalleryImages.splice(index, 1); // Remove the selected image by index
  setGalleryImages(updatedGalleryImages);
};
if (loading) {
  // Render loading screen
  
  return (
    <div className="loading-screen">
      
    <Loading/>
    </div>
  );
}
  return (
    <Container fluid className="mt-5">
        <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
      <Row className="align-items-center mb-4">
                <Col>
                    <h1>Scheme Management</h1>
                </Col>
                <Col className="text-end">
                   
                    <Button variant='info' className='btn me-2' onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faPlus} className="fa-icon" /> Add New Scheme
                    </Button>
                    <Button variant="success" className='btn btn me-2' onClick={downloadReport}>
                        <FontAwesomeIcon icon={faFileExcel} className="fa-icon" /> Download Report
                    </Button>
                    <Button onClick={() => setSchemeCategoryShowModal(true)}><FontAwesomeIcon icon={faChartBar} className="fa-icon" /> Add Category</Button>
                    
                </Col>
            </Row>
       
      <Tabs defaultActiveKey="active" id="scheme-tabs" className="mb-3">
      <Tab eventKey="active" title="Schemes">
      <Form.Control
        type="text"
        placeholder="Search schemes..."
        value={searchTerm1}
        onChange={(e) => setSearchTerm1(e.target.value)}
        className="mb-3"
      />

      {/* Table for listing schemes */}
      <Table  bordered hover>
        <thead>
          <tr>
            <th>Id</th>
            <th>Scheme Name</th>
            <th>Category</th>
            <th>Image</th>
            <th>Price</th>
            <th>Duration</th>
            <th>value of scheme</th>
            <th>Onboarding Dates</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
        {activeSchemes
          .filter((scheme) =>
            scheme.name.toLowerCase().includes(searchTerm1.toLowerCase())||
            scheme.id.toLowerCase().includes(searchTerm1.toLowerCase())
          )
          .map((scheme) => (
            <tr key={scheme.id}>
              <td>{scheme.id}</td>
              <td>
                <Link to={`/scheme/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                  {scheme.name}
                </Link>   
              </td>
              <td>{scheme.categoryName || '—'}</td>

              <td><img src={scheme.image} alt={scheme.name} width="50" /></td>
              <td>{scheme.price}</td>
              <td>{scheme.schemeDuration}</td>
              <td>{scheme.totalSchemeValue}</td>
              <td>{scheme.onboardingStart} to {scheme.onboardingEnd}</td>
              <td>
                <Button
                  variant={scheme.status ? 'success' : 'outline-secondary'}
                  className="btn"
                  onClick={() => handleToggleStatus(scheme.id, scheme.status)}
                >
                  {scheme.status ? 'Active' : 'Inactive'}
                </Button>
              </td>

              <td>
                <Button variant="outline-danger" className='btn m-1' onClick={() => handleDeleteScheme(scheme.id)}   disabled={scheme.status}>  <FontAwesomeIcon icon={faTrash} className="fa-icon" /></Button>
                <Button variant="outline-secondary" className='btn m-1'  onClick={() => openEditModal(scheme)}  disabled={scheme.status} style={{marginLeft:'5px'}}>  <FontAwesomeIcon icon={faEdit} className="fa-icon" /></Button>
                <Button
                  variant="outline-success"
                  className="btn m-1"
                  onClick={() => handleCompleteAndClose(scheme.id)}
                  disabled={scheme.status === 'Completed'} // Disable if already completed
                  style={{ marginLeft: '5px' }}
                >
                  <FaTruck/>
                </Button>
                 <Button variant="outline-secondary" className="btn m-1" onClick={() => handleDuplicateScheme(scheme)} disabled={scheme.status} style={{ marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faCopy} className="fa-icon" /> 
                  </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </Tab>
      <Tab eventKey="completed" title="Completed Schemes">
      <Form.Control
        type="text"
        placeholder="Search schemes..."
        value={searchTerm2}
        onChange={(e) => setSearchTerm2(e.target.value)}
        className="mb-3"
      />
        <Table  bordered hover>
          <thead>
            <tr>
              <th>Id</th>
              
              <th>Scheme Name</th>
              <th>Image</th>
              <th>Price</th>
              <th>Duration</th>
              <th>Value of Scheme</th>
              <th>Total users</th>
              <th>Completed users</th>
              <th>Completed At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {completedSchemes
          .filter((scheme) =>
            scheme.name.toLowerCase().includes(searchTerm2.toLowerCase())||
            scheme.id.toLowerCase().includes(searchTerm2.toLowerCase())
          )
          .map((scheme) => (
              <tr key={scheme.id}>
                <td>{scheme.id}</td>
                <td>
                  <Link to={`/processscheme/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                    {scheme.name}
                  </Link>
                </td>
                <td><img src={scheme.image} alt={scheme.name} width="50" /></td>
                <td>{scheme.price}</td>
                <td>{scheme.schemeDuration}</td>
                <td>{scheme.totalSchemeValue}</td>
                <td>{scheme.totalUsers}</td>
                <td>{scheme.completedUsers}</td>
                <td>{scheme.completedAt ? new Date(scheme.completedAt.seconds * 1000).toLocaleString() : 'Not Available'}</td>
              
                <td>
                <Button variant="outline-danger" className='btn m-1' onClick={() => handleDeleteScheme(scheme.id)}  >  <FontAwesomeIcon icon={faTrash} className="fa-icon" /></Button>
           
                  <Button variant="outline-secondary" className="btn m-1" onClick={() => handleDuplicateScheme(scheme)} style={{ marginLeft: '5px' }}>
                    <FontAwesomeIcon icon={faCopy} className="fa-icon" /> 
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
    </Tab>
    <Tab eventKey="bin" title="Bin">
       
       {/* Table for listing schemes */}
       <Table  bordered hover>
          <thead>
            <tr>
              <th>Id</th>
              
              <th>Scheme Name</th>
              <th>Image</th>
              <th>Price</th>
              <th>Duration</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {deletedSchemes.map((scheme) => (
              <tr key={scheme.id}>
                <td>{scheme.id}</td>
                <td>
                  <Link to={`/processscheme/${scheme.id}`} style={{ textDecoration: 'none', color: 'blue' }}>
                    {scheme.name}
                  </Link>
                </td>
                <td><img src={scheme.image} alt={scheme.name} width="50" /></td>
                <td>{scheme.price}</td>
                <td>{scheme.schemeDuration}</td>
              
                <td>
                  <Button variant="outline-success" className="btn m-1" onClick={() => handleRecover(scheme.id)} style={{ marginLeft: '5px' }}>
                    <FaArrowRotateLeft icon={faCopy} className="fa-icon" /> 
                  </Button>
                  {/* <Button variant="outline-danger" className="btn m-1" onClick={() => handleDeleteSchemeFully(scheme.id)} style={{ marginLeft: '5px' }}>
                    <FaTrash icon={faCopy} className="fa-icon" /> 
                  </Button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </Tab>

      </Tabs>

      {/* Modal for adding a new scheme */}
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{isEditing ? 'Edit Scheme' : 'Add New Scheme'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          <Form onSubmit={isEditing ? handleEditScheme : handleAddScheme}>
            <Row>
              <Col>
               <Form.Group controlId="schemeName">
                <Form.Label>Scheme Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={schemeData.name}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              </Col>
              <Col>
              <Form.Group controlId="schemeCategory" className="mb-3">
              <Form.Label>Scheme Category</Form.Label>
              <Select
                options={categories.map((cat) => ({
                  value: cat.id,
                  label: cat.name,
                }))}
                value={
                  selectedCategory
                    ? { value: selectedCategory.id, label: selectedCategory.name }
                    : null
                }
                onChange={(option) => setSelectedCategory(option ? { id: option.value, name: option.label } : null)}
                placeholder="Select a category"
                isClearable
              />
            </Form.Group>

              </Col>
            </Row>
             
            <Row>
            <Col>
            <Form.Group controlId="schemeDuration">
                <Form.Label>Scheme Duration</Form.Label>
                <Form.Select 
                  value={schemeData.schemeDuration || ''} 
                  onChange={(e) =>
                    setSchemeData({ ...schemeData, schemeDuration: e.target.value })
                  }
                  required
                >
                  <option value="" disabled>0</option>
                  {[...Array(12).keys()].map(i => (
                    <option key={i} value={i + 1}>{i + 1}</option>
                  ))}
                </Form.Select>
              </Form.Group>

             
            </Col>
            <Col>
              <Form.Group controlId="schemePrice">
                <Form.Label>Scheme Price</Form.Label>
                <Form.Control
                  type="number"
                  name="price"
                  value={schemeData.price}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Col>
            </Row>
           
            
          
            <Row>
              <Col>
                <Form.Group controlId="onboardingStart">
                  <Form.Label>Onboarding Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="onboardingStart"
                    value={schemeData.onboardingStart}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              
              </Col>
              <Col>
                <Form.Group controlId="onboardingEnd">
                <Form.Label>Onboarding End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="onboardingEnd"
                  value={schemeData.onboardingEnd}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              </Col>
            </Row>
            <Form.Group>
              <Row>
                <Col>
                <Form.Group controlId="schemeDescription">
                <Form.Label>Description</Form.Label>
              <ReactQuill
                  theme="snow"
                  value={schemeData.Description}
                  onChange={(html) => setSchemeData(prev => ({ ...prev, Description: html }))}
                  
                />
              </Form.Group>
                </Col>
                <Col>
                
                 <Form.Group controlId="schemesettlementDetails">
                <Form.Label>Settlement details</Form.Label>
              <ReactQuill
                  theme="snow"
                  value={schemeData.settlementDetails}
                  onChange={(html) => setSchemeData(prev => ({ ...prev, settlementDetails: html }))}
                  
                />
              </Form.Group>
                </Col>
              </Row>
            
              
           <Row>
            <Col md={8}>
            
            <Form.Label>Select Product</Form.Label>
            <Select
              options={products.map(product => ({
                value: product.id,
                label: product.name
              }))}
              value={products.find(p => p.id === selectedProduct.productId) ? {
                value: selectedProduct.productId,
                label: products.find(p => p.id === selectedProduct.productId).name
              } : null}
              onChange={(selectedOption) =>
                setSelectedProduct({ ...selectedProduct, productId: selectedOption?.value || "" })
              }
              placeholder="Select a product"
              isClearable
            />
            </Col>
            <Col>
            <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                value={selectedProduct.quantity}
                onChange={(e) =>
                  setSelectedProduct({ ...selectedProduct, quantity: e.target.value })
                }
              />
            
            </Col>
            <Col>
           <br/>
            <Button
                variant="outline-primary"
                className="mt-2 btn"
                onClick={handleAddProduct}
              >
                <FontAwesomeIcon icon={faPlus} className="fa-icon" /> Add 
              </Button>
            
            </Col>
           </Row>
            </Form.Group>
            <Row>
              
              <Col md={6}>
              <Form.Group controlId="SchemeStart">
                  <Form.Label>Scheme Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="SchemeStart"
                    value={schemeData.SchemeStart}
                    onChange={handleInputChange}
                    required
                  />
                </Form.Group>
              <Form.Group controlId="schemeImage">
              <Form.Label>Scheme Image</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                disabled={imageUploading}
              />
              {imageUploading && <Spinner animation="border" size="sm" />}
            </Form.Group>
            {schemeData.image && (
              <div className="mt-3">
                <img
                  src={schemeData.image}
                  alt="Scheme Preview"
                  style={{
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                  }}
                />
              </div>
            )}
              
<Form.Group controlId="galleryImages">
  <Form.Label>Gallery Images</Form.Label>
  <Form.Control
    type="file"
    accept="image/*"
    multiple // Allow multiple file selection
    onChange={handleGalleryImageUpload}
    disabled={imageUploading}
  />
  {imageUploading && <Spinner animation="border" size="sm" />}
</Form.Group>
        <Form.Group controlId="dueDateFrom" className="mt-3">
              <Form.Label>Late fee</Form.Label>
              <Form.Control
                type="number"
                value={schemeData.dueDateFrom || ''}
                onChange={(e) =>
                  setSchemeData({ ...schemeData, dueDateFrom: e.target.value })
                }
                placeholder='Due Date From (Day of Month)'
                required
              />
            </Form.Group>

            <Form.Group controlId="dueDateTo" className="mt-3">
             
              <Form.Control
                type="number"
                value={schemeData.dueDateTo || ''}
                onChange={(e) =>
                  setSchemeData({ ...schemeData, dueDateTo: e.target.value })
                }
                required
                placeholder='Due Date To (Day of Month)'
              />
            </Form.Group>

            <Form.Group controlId="lateFee" className="mt-3">
              
              <Form.Control
                type="number"
                value={schemeData.lateFee || ''}
                onChange={(e) =>
                  setSchemeData({ ...schemeData, lateFee: e.target.value })
                }
                required
                placeholder='late fee percentage(%)'
              />
            </Form.Group>
             
               <Form.Label>Single payment discount(in month quantity)</Form.Label>
              <Form.Control
                type="number"
                value={schemeData.singlePaymentDiscount||0 }
                onChange={(e) =>
                  setSchemeData({ ...schemeData, singlePaymentDiscount: e.target.value })
                }
                min={0}
                required
                placeholder='Single payment discount (in months)'
              />
       

              </Col>
              <Col md={6}>
              <br/>
              <Form.Label>Selected Products</Form.Label>
              <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
              <ul className="list-group">
                {schemeData.productDetails.map((product, index) => (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <span style={{ fontSize: '14px' }}>
                      {product.productName} - Quantity: {product.quantity}
                    </span>
                    <button
                          type="button" // Prevents form submission
                          className="btn btn-outline-danger btn"
                          onClick={() => handleRemoveProduct(index)}
                      >
                          <FontAwesomeIcon icon={faXmark} size='sm'/> 
                      </button>
                  </li>
                ))}
              </ul>
              </div>

<br/>
            {/* Display uploaded gallery images */}
            <Form.Label>Gallery Images</Form.Label>
            <div style={{ maxHeight: '150px', overflowY: 'auto', marginTop: '10px' }}>
              <ul className="list-group">
                {galleryImages.map((image, index) => (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <img src={image} alt={`Gallery ${index}`} width="100" height="70" style={{ marginRight: '10px' }} />
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm"
                      onClick={() => handleRemoveGalleryImage(index)}
                    >
                      <FontAwesomeIcon icon={faXmark} size="sm" />
                    </button>
                  </li>
                ))}
              </ul>
            </div>
              
              </Col>
             
            </Row>
           
            
            
           
            
            
            <br/>
            <Button variant="success" className='btn btn' type="submit">
              <FontAwesomeIcon icon={faFloppyDisk} className="fa-icon" /> {isEditing ? 'Update Scheme' : 'Add Scheme'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
       <SchemeCategoryModal
        show={showSchemeCategoryModal}
        handleClose={() => setSchemeCategoryShowModal(false)}
      />
    </Container>
  );
};

export default Schemes;